export default __webpack_public_path__ + "static/media/communication.fb4c31bb.jpg";